export const workerComponentTypes = [
  { label: 'Unknown', value: 1 },
  { label: 'Gold', value: 2 },
]
